export const initialState = {
    name: "",
    cel: "",
    name_vehicle: "",
    color: "",
    license_plate: "",
    data_entrada: "",
    hora_entrada: ""
}